export const ApprovalRequestTypesEnum = {
  General: {
      key: 1,
      value: 'general',
  },
  JobRequisition: {
    key: 'job-requisition-budgeted',
    value: "budgeted-requisition",
    numericKey: 2
  },
  JobRequisitionNonBudgeted: {
    key: 'job-requisition-non-budgeted',
    value: "non-budgeted-requisition",
    numericKey: 2
  },
  JobPost: {
    key: 3,
    value: "job-post",
  },
  JobOffer: {
    key: 4,
    value: "job-offer",
  },
  FormRequest: {
    key: 9,
    value: "form-request",
  },
 ChangeRequest: {
    key: 10,
    value: "change-request",
  },
  Contract: {
      key: 6,
      value: 'contract',
  },
  // Interview: {
  //     key: 5,
  //     value: 'interview',
  // },
  // Rehire: {
  //     key: 7,
  //     value: 'rehire',
  // },
  // Relative: {
  //     key: 8,
  //     value: 'relative',
  // },
};
